// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

var _map = {"Register":"register","PlaceBid":"placebid","LiveRoomLoad":"live-room_load"};

var _revMap = {"register":"Register","placebid":"PlaceBid","live-room_load":"LiveRoomLoad"};

function sliNameToJs(param) {
  return _map[param];
}

function sliNameFromJs(param) {
  return _revMap[param];
}

var _map$1 = {"Good":"good","Bad":"bad"};

var _revMap$1 = {"good":"Good","bad":"Bad"};

function stateTypeToJs(param) {
  return _map$1[param];
}

function stateTypeFromJs(param) {
  return _revMap$1[param];
}

var hasFunction = (function (func) { return !!(window.SLI && window.SLI[func]) });

function send(state, duration, name) {
  var sli = window.SLI;
  if (sli !== undefined) {
    sli.send(sliNameToJs(name), {
          state: Belt_Option.map(state, stateTypeToJs),
          durationMs: duration
        });
    return ;
  }
  
}

function startTimer(name, ttl) {
  var sli = window.SLI;
  if (sli !== undefined && hasFunction("startTimer")) {
    sli.startTimer(sliNameToJs(name), ttl);
    return ;
  }
  
}

function endTimer(stateOpt, name) {
  var state = stateOpt !== undefined ? stateOpt : "Good";
  var sli = window.SLI;
  if (sli !== undefined && hasFunction("endTimer")) {
    sli.endTimer(sliNameToJs(name), stateTypeToJs(state));
    return ;
  }
  
}

export {
  sliNameToJs ,
  sliNameFromJs ,
  stateTypeToJs ,
  stateTypeFromJs ,
  hasFunction ,
  send ,
  startTimer ,
  endTimer ,
}
/* No side effect */
